// extracted by mini-css-extract-plugin
export default {"SignIN":"auth_SignIN__9o0SO","Peer":"auth_Peer__d62or","Peer-first:hidden":"auth_Peer-first-hidden__Hkmjc"};